import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-history",
  "use": "icon-history-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-history\"><path d=\"M16.76 3A13.2 13.2 0 0 0 3.6 14.57H2l3.03 3.74 3.02-3.74H5.9a10.9 10.9 0 0 1 10.87-9.33c6.07 0 10.97 4.83 10.97 10.83 0 5.99-4.9 10.82-10.97 10.82-3.99 0-7.47-2.07-9.4-5.2L5.5 22.95a13.28 13.28 0 0 0 11.26 6.18c7.3 0 13.24-5.86 13.24-13.06S24.06 3 16.76 3m-1.14 5.97v7.63l.43.34 4.67 3.69 1.42-1.75-.89-.7-3.36-2.65V8.97z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol